import { ComboBox, TextInput } from '@components';
import React, { useState } from 'react';

export const Dependente = ({ dependente, index }) => {
  const [exibirDetalhes, setExibirDetalhes] = useState(false);

  const handleVerMaisClick = () => {
    setExibirDetalhes((prev) => !prev);
  };

  return (
    <div className="card mb-32">
      <p className="mb-32 text-muted ts-14">
        Dependentes legais para imposto de renda
      </p>
      <h1 className="fw-bold ts-24 mb-4">Dependente {index + 1}</h1>
      <div className="row">
        <TextInput
          className="mb-6"
          label="Nome completo"
          value={dependente.nome}
          disabled
        />
        {exibirDetalhes && (
          <>
            <div className="col-md-12 col-lg-6">
              <TextInput
                className="mb-3"
                label="CPF"
                value={dependente.cpf}
                disabled
              />
              <ComboBox
                className="mb-3"
                label="Sexo"
                value={dependente.sexo}
                options={['Masculino', 'Feminino', 'Outros'].map((s) => {
                  return { value: s, label: s };
                })}
                disabled
              />
              <TextInput
                className="mb-3"
                label="É estudante?"
                value={dependente.isEstudante ? 'Sim' : 'Não'}
                disabled
              />
            </div>
            <div className="col-md-12 col-lg-6">
              <TextInput
                className="mb-3"
                label="Nascimento"
                value={dependente.dataNascimento}
                disabled
              />

              <TextInput
                className="mb-3"
                label="Parentesco"
                value={dependente.parentesco}
                disabled
              />
              <TextInput
                className="mb-3"
                label="É inválido?"
                value={dependente.isInvalido ? 'Sim' : 'Não'}
                disabled
              />
            </div>
          </>
        )}
      </div>
      <div className="text-center my-3">
        <button
          type="button"
          className="btn btn-primary white"
          onClick={handleVerMaisClick}
        >
          {exibirDetalhes ? 'Ver Menos' : 'Ver Mais'}
        </button>
      </div>
    </div>
  );
};
